import { POSITION_END} from './positionEndTypes'

const initialState = {
    positionEnd: ""
}

const positionEndReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case POSITION_END:
            
            return {
                positionEnd: action.load
            }
    
        default:
          return state
    }

}


export default positionEndReducer;